import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 同步合作商品库存
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function syncPartnerGoodsStock(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/partner.syncPartnerGoodsStock',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}